// DS1.7.17
import React from 'react';
import classnames from 'classnames';
import s from './BirthdayBadge.scss';

interface Props {
  size: 16 | 20 | 24 | 32 | 40;
  className?: string;
}

const BirthdayBadge: React.FC<Props> = ({ size, className }) => {
  return (
    <img
      src="https://st.deviantart.net/eclipse/global/svg/birthday-badge.svg"
      alt=""
      className={classnames(s['root'], s[`size-${size}`], className)}
    />
  );
};
BirthdayBadge.displayName = 'BirthdayBadge';

export default BirthdayBadge;
